import {
  Checkbox,
  Divider,
  Dropdown,
  Form,
  Input,
  Select,
  Table,
  Tag,
  TimePicker,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import svg80 from "../../../../../assets/svg/svg80.svg";
import moment from "moment";
import svg77 from "../../../../../assets/svg/svg77.svg";
import Search from "../../../../../components/Search";
import { fetchData } from "../../../../../features/dropdown/dropdownSlice";
import ProfileView from "../../../jobs/recommendation/ProfileView";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import { formatText } from "../../../../../utils";
import { setSelectedCandidates } from "../../../../../features/folder/folderSlice";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "time" ? (
      <TimePicker format="HH:mm" className="w-full input" id="input-focus" />
    ) : (
      <Input
        id="input-focus"
        className="input"
        placeholder={`Enter ${title}`}
      />
    );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          className="table-form-item"
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `${title} is required`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function Manual() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectId, setSelectId] = useState();
  const url = "api/v1/applications/filter";

  const { loading, data, count, activeObjActivity } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjActivity: state.folder.activeObj["activity"],
  }));
  const { open, handleCancel, handleOpen } = useModalToggle();

  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const [prodd1, setProdd1] = useState();
  const handleViewName = async (item) => {
    await setProdd1(item);
    await showDrawer();
  };
  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        damName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const [dataSource, setDataSource] = useState(data);

  useEffect(() => {
    setDataSource(data);
  }, [data]);
 
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState("");

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record?.mbiId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      japInterviewStartTime: record.japInterviewStartTime
        ? dayjs(record.japInterviewStartTime, "HH:mm")
        : null,
      japInterviewEndTime: record.japInterviewEndTime
        ? dayjs(record.japInterviewEndTime, "HH:mm")
        : null,
    });
    setEditingKey(record?.mbiId);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item?.mbiId);

      if (index > -1) {
        const item = newData[index];

        // Format time values
        const updatedObj = {
          ...item,
          ...row,
        };

        if (
          updatedObj.japInterviewStartTime &&
          dayjs.isDayjs(updatedObj.japInterviewStartTime)
        ) {
          updatedObj.japInterviewStartTime =
            updatedObj.japInterviewStartTime.format("HH:mm");
        }
        if (
          updatedObj.japInterviewEndTime &&
          dayjs.isDayjs(updatedObj.japInterviewEndTime)
        ) {
          updatedObj.japInterviewEndTime =
            updatedObj.japInterviewEndTime.format("HH:mm");
        }

        newData.splice(index, 1, updatedObj);
        setDataSource(newData);
        await dispatch(setSelectedCandidates(newData))
        setEditingKey("");
        console.log("Saved successfully:", updatedObj);
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const handleAdd = () => {
    const lastRow = dataSource[dataSource.length - 1];
    if (
      lastRow &&
      (!lastRow.mbiName ||
        !lastRow.japInterviewStartTime ||
        !lastRow.japInterviewEndTime ||
        editingKey === lastRow.mbiId)
    ) {
      return;
    }

    const newId = Date.now();
    const newRow = {
      mbiId: newId,
      mbiName: "",
      japInterviewStartTime: null,
      japInterviewEndTime: null,
    };

    setDataSource([...dataSource, newRow]);
    setEditingKey(newId);

    // Set form values for the new row
    setTimeout(() => {
      form.setFieldsValue({
        mbiName: "",
        japInterviewStartTime: null,
        japInterviewEndTime: null,
      });
    }, 100);
  };

  const handleRemove = () => {
    const updatedData = dataSource.filter(
      (item) => !selectedRowKeys.includes(item.mbiId)
    );
    setDataSource(updatedData);
    setSelectedRowKeys([]);
  };

  const handleDeleteRow = (id) => {
    const updatedData = dataSource.filter((item) => item.mbiId !== id);
    setDataSource(updatedData);
    if (editingKey === id) setEditingKey("");
  };

  const defaultColumns = [
    {
      title: "#",
      dataIndex: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Applicant",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
    },
    {
      title: "Match Score",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    },
    {
      title: "Date Shortlisted",
      dataIndex: "japShortlistedDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.japShortlistedDate).valueOf() -
        moment(b.japShortlistedDate).valueOf(),
    },
    {
      title: "Start Time",
      dataIndex: "japInterviewStartTime",
      editable: true,
    },
    {
      title: "End Time",
      dataIndex: "japInterviewEndTime",
      editable: true,
    },
    {
      title: "Progress Status",
      dataIndex: "japProgressStatus",
      render: (item) => {
        const colors = {
          DRAFT: "#706F6F",
          SHORTLIST: "#FDB505",
          SCHEDULE_INTERVIEW: "#DAA520",
          OFFER: "#569D6E",
          HIRE: "#569D6E",
          DROP: "#C62130",
        };

        return (
          <div
            className="bg-[#E8EEED] inline-block rounded-[8px] px-[1rem] py-[.25rem] w-auto !font-[500] !text-[1rem]"
            style={{
              color: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="flex w-fit items-center gap-[1rem]">
            <button onClick={cancel} className="modal_btn_light" type="button">
              Cancel
            </button>
            <button
              type="button"
              onClick={() => saveFunction(record?.mbiId)}
              className="modal_btn_dark"
            >
              Save
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <img
              src={svg80}
              alt="svg80"
              className="cursor-pointer"
              onClick={() => edit(record)}
            />
          </div>
        );
      },
    },
  ];

  const mergedColumns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType:
          col.dataIndex === "japInterviewStartTime" ||
          col.dataIndex === "japInterviewEndTime"
            ? "time"
            : "text",
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const statusMap = {
    Submitted: { value: "DRAFT", label: "Submitted" },
    Shortlisted: { value: "SHORTLIST", label: "Shortlisted" },
    Scheduled_Interview: {
      value: "SCHEDULE_INTERVIEW",
      label: "Scheduled_Interview",
    },
  };

  const plainOptions = Object?.values(statusMap)?.map(({ value, label }) => ({
    value,
    label,
  }));

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        jobId: activeObjActivity?.jaaJobId,
        progressStatuses: selectedFilters,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [selectedFilters]);
  return (
    <>
      <div className="flex lg:flex-row flex-col lg:items-center justify-between mt-[1rem]">
        <div className="flex items-center gap-[1rem]">
          <div className="lg:w-[35.125rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>

          <Dropdown
            overlay={filterOverlay}
            trigger={["click"]}
            placement="bottom"
            open={popoverVisible}
            onOpenChange={(visible) => setPopoverVisible(visible)}
          >
            <div className="flex items-center cursor-pointer text-[#706F6F] text-[.875rem] font-[400] font-dmSans">
              <span>Filter</span>
              <img src={svg77} alt="filter icon" className="ml-1" />
            </div>
          </Dropdown>
        </div>
      </div>
      <div className="mt-[1.25rem]">
        {selectedFilters &&
          selectedFilters?.map((status) => {
            const matchedOption = plainOptions?.find(
              (opt) => opt?.value === status
            );
            const label = matchedOption ? matchedOption.label : status;

            const statusColors = {
              Submitted: "#706F6F",
              Shortlisted: "#FDB505",
              Scheduled_Interview: "#DAA520",
              Offer: "#569D6E",
              Hired: "#569D6E",
              Dropped: "#C62130",
            };

            return (
              <Tag
                closeIcon
                onClose={handleRemoveFilter(status)}
                className="inline-block w-fit max-w-max px-[.5rem] py-[.25rem] bg-[#E8EEED]
                           rounded-[2.1875rem] text-[.75rem] font-[400]"
                style={{ color: statusColors[label] || "#000" }}
              >
                {label}
              </Tag>
            );
          })}
      </div>
      <div className="max-w-full w-full overflow-x-auto mt-[1.5rem]">
        <Form form={form} component={false}>
          <Table
            className="editable_table"
            size="large"
            bordered={false}
            rowSelection={false}
            columns={mergedColumns}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            dataSource={dataSource}
            rowKey="japId"
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </Form>
      </div>

      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd1}
        action={false}
      />
    </>
  );
}
